import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/tools/family-snapshot")({
  component: () => <Outlet />,
});